import React, { Fragment } from "react";
import styled from 'styled-components';
import I10n from '../../../features/i10n';
import Scrollbars from 'react-custom-scrollbars';
import MsxIcons from '../../msx-icons';
import { getLicenceSelectorQuestions } from "../../screens/licence_selector_screen/ducks";
import Button from "../../../atoms/button";
import LicenceSelectorQuestionGroup from "../../../components/licence_selector_question_group";
import { answerIsActive, disjunctionConditionsMatchingUserAnswers, questionIsActive } from "../../screens/licence_selector_screen/utils";
import { SECONDARY_COLOR } from "../../../color-constants";
import CustomNotification from "../../../components/customNotification";
import LicenseSelectorPackageSummary from "../../../components/software_licence/license_selector_package_summary";
import Skeleton from "../../../components/skeleton";
import LicenseSelectorPackageSummaryContent from "../../../components/software_licence/license_selector_package_summary_content";
import { buildLicenseGroups } from "../../../utils/software-licenses";
const Parser = require('expr-eval').Parser;

const Container = styled.div`
  ${props => props.$windowModeEnabled ? `
    border-radius: 10px;
    align-self: center;
    display: flex;
    flex-direction: column;
    margin: 2em;
    max-width: 1100px;
    width: 100%;
    background-color: #F4F4F4;
    height: calc(100vh - 4em);
    overflow: hidden;
    @media (max-width: 800px) {
      max-width: 100%;
      margin: 2em 0;
    }

  ` : `
    align-self: center;
    display: flex;
    flex-direction: column;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    height: 100%;
    max-height: 100%;
    box-sizing: content-box;
    background-color: #F4F4F4;
    color: #333333;
  `}
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${SECONDARY_COLOR};
  background: var(--se-primary, ${SECONDARY_COLOR});
  color: white !important;
  color: var(--se-primary-contrast, white) !important;
  margin: 0px;
  padding: 15px 20px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-size: 24px;
  font-weight: 700;
`;

const CloseIcon = styled.span`
  display: inline-block;
  cursor: pointer;
`;

const ContentAndSubmitWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const Content = styled.div`
  display: flex;
  flex: 1 1 auto;
  padding: 10px 20px 0px 20px;
  overflow: hidden;
`;

const ScrollbarContent = styled.div`
  padding-right: 8px;
`;

const SubmitWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px;
`;

const StepperWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  height: 60px;
  @media (max-width: 800px) {
    overflow-y: hidden;
    overflow-x: auto;
  }
`;

const StepperScrollbarContent = styled.div`
  display: flex;
  padding: 0px 15px;
`;

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  cursor: pointer;
  color: #626469;
  position: relative;
  ${props => props.$disabled ? 'pointer-events: none;' : ''}
`;

const StepLineWrapper = styled.div`
  display: flex;
`;

const Line = styled.div`
  display: flex;
  flex: 1 2 0px;
  height: 1px;
  margin-top: 12px;
  ${props => (props.$done ? `background-color: ${SECONDARY_COLOR}; background-color: var(--se-primary, ${SECONDARY_COLOR});` :
    'background-color: #9FA0A4;')};
`;

const EmptySpace = styled.div`
  display: flex;
  flex: 1 2 0px;
`;

const StepInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  padding-bottom: 5px;
  white-space: nowrap;
`;

const StepTitle = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #626469;
  text-transform: uppercase;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 800px) {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
  }

  @media (max-width: 650px){
    max-width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const CircleWrapper = styled.span`
  position: relative;
  box-sizing: content-box;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 5px;
  display: inline-flex;
  justify-content: center;
  z-index: 1;
  background-color: white;
  background-size: 10px;
  background-repeat: no-repeat;
  background-position: center center;
  border: 2px solid #626469;

  ${props => props.$disabled ? 'border: 2px solid #E7E6E6;' : ''}

  ${props => props.$active ? `
    border: 2px solid ${SECONDARY_COLOR};
    border: 2px solid var(--se-primary, ${SECONDARY_COLOR});
  ` : ''}

  ${props => props.$done ? `
    background-color: ${SECONDARY_COLOR};
    background-color: var(--se-primary, ${SECONDARY_COLOR});

    border: 2px solid ${SECONDARY_COLOR};
    border: 2px solid var(--se-primary, ${SECONDARY_COLOR});

    color: white;
    color: var(--se-primary-contrast, white);
  `: ``}

`;

const MsxIconsSvg = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`

const EmptyCircle = styled.div`
  position: absolute;
  top: 0px;left: 0px;right: 0px;bottom: 0px;
  background-color: white;
  border-radius: 50%;
`;

const CircleMask = styled.div`
  position: absolute;
  top: -2px;left: -2px;right: -2px;bottom: -2px;
  background-color: black;
  opacity: 0.2;
  border-radius: 50%;
`;

const LicenseSelectorPackageSummaryWrapper = styled.div`
  display: flex;
  flex: 1 2 0px;
  max-height: 100%;
  margin-left: 10px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const MobilePackageSummaryWrapper = styled.div`
  display: none;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
  cursor: pointer;

  ${props => props.$isOpen ? '' : 'box-shadow: 0px 2px 16px 0px #00000040;'}

  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobilePackageSupparyLabel = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #000000;
`;

const MobileChipAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MobileIconWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  margin-left: 10px;
  cursor: pointer;
`;

const MobilePackageSummaryPositioner = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: none;
  flex-direction: column;
  pointer-events: none;

  @media (max-width: 800px) {
    display: flex;
  }
`;

const MobilePackageSummaryContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: white;
  flex: 0 0 0px;
  pointer-events: auto;
  ${props => props.$isOpen ? 'flex: 1 1 0px;' : ''}

  transition: all 0.5s;
`;

const SkeletonWrapper = styled.div`
  width: 100%;
  box-sizing: content-box;
`;

const PreviousWrapper = styled.div`
  margin-right: 10px;
`;

const ContentScrollbarsWrapper = styled.div`
  display: flex;
  flex: 2 1 0px;
  margin-right: -5px;
`;

const Counter = styled.div`
  background-color: #2E3638;
  color: white;
  display: inline-block;
  line-height: 0px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 400;
`;

const CounterLabel = styled.div`
  display: inline-block;
  padding-top: 50%;
  padding-bottom: 50%;
  margin-left: 8px;
  margin-right: 8px;
`;

const ValidateWrapper = styled.div`
  display: none;

  @media (max-width: 800px) {
    display: flex;
  }
`;

class ModalSoftwareLicenceSelector extends React.PureComponent {

  constructor(props) {
    super(props);
    const parser = new Parser();
    parser.functions.modulo = function (arg1, arg2) {
      return arg1 % arg2;
    };

    parser.functions.isScoped = function (licenseId) {
      if ((props.scopedLicences || {})[licenseId]) {
        return 1;
      }
      return 0;
    }

    const baseAnswers = {
      'licenceType': props.licenceType,
      'licenseModel': props.licenseModel,
      'licenseLevel': props.licenseLevel,
      'optimizeLicenses': 'false'
    };

    for (const startCriteria of (props.startCriterias || []) ) {
      baseAnswers[startCriteria.criteria] = startCriteria.value;
    }

    this.state = {
      parser,
      steps: [],
      formulas: {},
      optimizationItems: {},
      advancedOptimizationGroups: [],
      availableReferences: {},
      stepsLoading: false,
      activeStepIndex: 0,
      answers: baseAnswers,
      mobilePackageSummaryOpen: false,
      optimizeLicenses: false,
      showNotification: false,
      notificationType: null,
      notificationText: null
    };
    this._isMounted = false;
  }


  /**
   * Append the still used criteria to the result map given as parameter.
   *
   * @param {*} result
   * @param {*} activeIf
   * @returns
   */
  appendActivableCriteria = (result, activeIf) => {
    activeIf.forEach(conjunction => {
      conjunction.disjunctions.filter(disj => !disj.negation).forEach(disj => {
        disj.values.forEach(val => {
          result[disj.key + '_' + val] = true;
        });
      });
    });
  }

  /**
   * Retrieve the criteria which are present in the active if of the
   * still visible questions.
   *
   * @param {*} steps
   *
   * @returns criteria still activable
   */
  getActivableCriteria = (steps) => {
    const result = {};

    steps.forEach(step => {
      step.questionGroups.forEach(qg => {
        qg.questions.forEach(q => {
          q.answers.forEach(answer => {
            this.appendActivableCriteria(result, answer.activeIf)
          });
          this.appendActivableCriteria(result, q.activeIf);
        });
        this.appendActivableCriteria(result, qg.activeIf);
      });
      this.appendActivableCriteria(result, step.activeIf);
    });

    return result;
  }

  /**
   * Filter the answers which are still relevant :
   *
   * - Answer which will activate at least another answer
   * - Answer which is used for a scoped formula
   *
   *
   * @param {*} steps
   * @param {*} formulaCriteria
   * @returns the updated steps
   */
  getStillActivableAnswers = (steps, formulaCriteria) => {
    let hasFilteredAnAnswer = false;

    const activableCriteria = this.getActivableCriteria(steps);

    steps.forEach(s => {
      s.questionGroups = s.questionGroups.filter(qg => {
        qg.questions = qg.questions.filter(q => {

          const currentNbOfAnswers = q.answers.length;

          q.answers = q.answers.filter(a => {

            /**
             * Special case for criteria which needs to be displayed if there is at least one other answer in their question.
             * These answer are not used in a formula, or in active if.
             */
            if (a.hideIfSingleAnswer) {
              if (currentNbOfAnswers === 1) {
                hasFilteredAnAnswer = true;
                return false;
              } else {
                return true;
              }
            }

            // Remove the answer if it is not visible in an active if, or if it is not used in a formula.
            const shouldRemoveAnswer = (a.type !== 'list' && (activableCriteria[a.criteria + "_" + (a.type === 'number' ? null : a.value)] == null && (formulaCriteria[a.criteria + "_" + (a.type === 'number' ? null : a.value)] == null)));

            if (shouldRemoveAnswer) {
              hasFilteredAnAnswer = true;
              return false;
            }

            return true;
          });
          return q.answers.length > 0;
        });
        return qg.questions.length > 0;
      });
    });

    return {newSteps: steps.filter(step => step.questionGroups.length > 0), hasFilteredAnAnswer};
  }

  /**
   * Remove the answers if they were used in a descoped formula.
   *
   * @param {*} steps
   * @param {*} questionCriteria
   * @returns
   */
  filterAnswersIfUnscoped = (steps, questionCriteria) => {
    let hasFilteredAnAnswer = false;

    const newSteps = steps.filter(step => {
      step.questionGroups = step.questionGroups.filter(group => {
        group.questions = group.questions.filter(question => {
          question.answers = question.answers.filter(a => {

            if (a.type === 'list') {
              // Remove from the update mapping the unscopped
              a.updateMapping = a.updateMapping.filter(row => {
                return questionCriteria[row.previousLicence + "_" + null] == null;
              });
              if (a.updateMapping.length === 0) {
                hasFilteredAnAnswer = true;
                return false;
              }
              return true;
            }

            if (questionCriteria[a.criteria + '_' + (a.type === 'number' ? null : a.value)] === true) {
              hasFilteredAnAnswer = true;
              return false;
            }
            return true;
          });
          return question.answers.length > 0;
        });
        return group.questions.length > 0;
      });
      return step.questionGroups.length > 0;
    });

    return {newSteps, hasFilteredAnAnswer};
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateStateIfMounted({steps: [], stepsLoading: true});
    getLicenceSelectorQuestions(this.props.softwareSelection, this.props.licenceType).then((payload) => {

      const {usedFormulaCriteria, filteredFormulaCriteria} = this.extractUsedAndUnusedFormulasVariables(payload.formulas.filter(formula => {
        return (formula.softwareLicence?.licenseModels || []).includes(this.props.licenseModel);
      }) || [], this.props.scopedLicences);

      let {newSteps, hasFilteredAnAnswer} = this.filterAnswersIfUnscoped(payload.steps, filteredFormulaCriteria);
      do {
        const newActivableStatus = this.getStillActivableAnswers(newSteps, usedFormulaCriteria);
        newSteps = newActivableStatus.newSteps;
        hasFilteredAnAnswer = newActivableStatus.hasFilteredAnAnswer;
      }
      while (hasFilteredAnAnswer);

      const availableReferences = {};
      const availableFormulas = {}
      for (const formula of (payload.formulas || [])) {
        availableReferences[formula.id] = formula.softwareLicence;
        availableFormulas[formula.id] = formula;
      }

      const optimizationItems = {};
      for (const item of (payload.optimizationItems || [])) {
        optimizationItems[item.optimizedReference] = item;
      }

      this.updateStateIfMounted({
        steps: newSteps || [],
        formulas: availableFormulas || {},
        optimizationItems,
        advancedOptimizationGroups: payload.advancedOptimizationGroups || [],
        availableReferences,
        stepsLoading: false});
    }).catch(() => {
      this.updateStateIfMounted({steps: [], stepsLoading: false});
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  getVisibleSelectedCriteriaForAnswers = (answers) => {
    const visibleCriteria = {
      licenceType: true,
      licenseModel: true,
      licenseLevel: true,
      optimizeLicenses:true
    };
    if (this.state.steps) {
      this.state.steps.forEach((step) => {
        if (step && disjunctionConditionsMatchingUserAnswers(step.activeIf || [], answers)) {
          if (step.questionGroups) {
            step.questionGroups.forEach(group => {
              if (group && disjunctionConditionsMatchingUserAnswers((group.activeIf || []), answers)) {
                if (group.questions) {
                  group.questions.forEach(question => {
                    if (question && disjunctionConditionsMatchingUserAnswers(question.activeIf || [], answers)) {
                      if (question.answers) {
                        question.answers.forEach(answer => {
                          // Check if we still see the selected answer, if not it should be erased, special case for the number values (as their value is dynamic)
                          if (answer && disjunctionConditionsMatchingUserAnswers(answer.activeIf || [], answers) && (answer.type === 'number' || (answers[answer.criteria] === answer.value))) {
                            visibleCriteria[answer.criteria] = true;
                          }
                          // Special case for list answer, also consider the updateMapping field
                          if (answer && answer.type === 'list' && answer.updateMapping) {
                            answer.updateMapping.filter(correspondance => answers[correspondance.correspondanceId]).forEach((correspondance) => {
                              visibleCriteria[correspondance.correspondanceId] = true;
                            });
                          }
                        })
                      }
                    }
                  });
                }
              }
            });
          }
        }
      });
    }
    return visibleCriteria;
  }

  questionGroupIsActive = (questionGroup, userAnswers) => {
    let isActive = disjunctionConditionsMatchingUserAnswers(questionGroup.activeIf || [], userAnswers);
    let atLeastOneQuestionActive = false;

    for (let i = 0; i < questionGroup.questions.length && !atLeastOneQuestionActive;  i++) {
      if (questionIsActive(questionGroup.questions[i], userAnswers)) {
        atLeastOneQuestionActive = true;
      }
    }

    return isActive && atLeastOneQuestionActive;
  }

  getActiveAnswers = (question, userAnswers) => {
    const activeAnswers = [];

    for (let i = 0; i < question.answers.length; i++) {
      if (answerIsActive(question.answers[i], userAnswers)) {
        activeAnswers.push(question.answers[i]);
      }
    }

    return activeAnswers;
  }

  getActiveQuestions = (questionGroup, userAnswers) => {
    let activeQuestions = [];

    for (const question of questionGroup.questions) {
      if (questionIsActive(question, userAnswers)) {
        activeQuestions.push(question);
      }
    }

    return activeQuestions;
  }

  getActiveQuestionGroups = (questionGroups, userAnswers) => {
    let activeQuestionsGroups = [];

    for (const questionGroup of questionGroups) {
      if (this.questionGroupIsActive(questionGroup, userAnswers)) {
        activeQuestionsGroups.push(questionGroup);
      }
    }

    return activeQuestionsGroups;
  }

  extractCriteriaFromAnswers = (answers) => {
    const result = [];

    answers.forEach(answer => {
      result.push(answer.criteria);
    });

    return result.filter(function(item, pos, self) {
      return self.indexOf(item) === pos;
    });
  }

  /**
   * Check if all visible mandatory questions have been answered.
   */
  allMandatoryQuestionsHaveBeenAnswered = () => {
    let allMandatoryAnswered = true;
    let unansweredQuestionElement = null;

    const activeQuestionsGroups = this.getActiveQuestionGroups((this.state.steps[this.state.activeStepIndex]?.questionGroups || []), this.state.answers);

    for (let i = 0; i < activeQuestionsGroups.length && allMandatoryAnswered; i++) {
      const activeQuestions = this.getActiveQuestions(activeQuestionsGroups[i], this.state.answers);

      for (let j = 0; j < activeQuestions.length && allMandatoryAnswered; j++) {
        const question = activeQuestions[j];
        if (question.mandatory) {
          const activeAnswers = this.getActiveAnswers(question, this.state.answers);
          const criteriaToBeFilled = this.extractCriteriaFromAnswers(activeAnswers);
          let numberOfCriteriaFilled = 0;
          for (let k = 0; k < criteriaToBeFilled.length; k++) {
            if (this.state.answers[criteriaToBeFilled[k]] != null ) {
              numberOfCriteriaFilled++;
            }
          }

          if ((question.mandatoryType === 'one' && numberOfCriteriaFilled === 0) || (question.mandatoryType === 'full' && criteriaToBeFilled.length !== numberOfCriteriaFilled)) {
            allMandatoryAnswered = false;
            unansweredQuestionElement = document.getElementById(question.key);
          }
        }
      }
    }

    return { allMandatoryAnswered, unansweredQuestionElement };
  }

  /**
   * Get the software licences as a map.
   *
   * @returns map of software licences
   */
  getSoftwareLicenciesWithQuantity () {
    const result = {};
    for (const licence of this.props.softwareLicences) {
      result[licence.id] = licence;
    }
    return result;
  }

  renderActiveQuestionsGroups = () => {

    const activeQuestionsGroups = this.getActiveQuestionGroups((this.state.steps[this.state.activeStepIndex]?.questionGroups || []), this.state.answers);

   return activeQuestionsGroups.map((group, index) => (
      <LicenceSelectorQuestionGroup
        key={index}
        questionGroup={group}
        userAnswers={this.state.answers}
        setAnswer={this.setAnswer}
        clearAnswers={this.clearAnswers}
        softwareLicencesMap={this.getSoftwareLicenciesWithQuantity()}
      />
    ));
  }

  computeNewVisibleSelectedCriteria = (baseAnswers) => {

    // This will clear all previous answers which are no longer visible.
    let current = baseAnswers;
    let previous = {};

    while (Object.keys(current).length !== Object.keys(previous).length) {
      previous = current;
      const newVisibleSelectedCriteria = this.getVisibleSelectedCriteriaForAnswers(current);
      const newAnswers = {};

      for (const key of Object.keys(newVisibleSelectedCriteria)) {
        newAnswers[key] = current[key];
      }

      current = newAnswers;
    }

    // Affect the licenceType and licenseModel, this is useful for some formula.
    current['licenceType'] = this.props.licenceType;
    current['licenseModel'] = this.props.licenseModel;
    current['licenseLevel'] = this.props.licenseLevel;
    current['optimizeLicenses'] = this.state.optimizeLicenses ? 'true' : 'false';

    return current;
  }

  clearAnswers = (criteriaToClear) => {
    // Affect the new answer
    const updatedAnswers = JSON.parse(JSON.stringify(this.state.answers));

    criteriaToClear.forEach(criteria => {
      delete updatedAnswers[criteria];
    });

    this.updateStateIfMounted({answers: this.computeNewVisibleSelectedCriteria(updatedAnswers)});
  }

  setAnswer = (key, value, question, answer) => {

    // Affect the new answer
    const updatedAnswers = JSON.parse(JSON.stringify(this.state.answers));

    // Clear already selected answer from same question if the new answer has the "reset" type marked as "unique".
    if (answer.reset === 'unique') {
      question.answers.forEach((answerItem) => {
        delete updatedAnswers[answerItem.key];
      });
    } else {
      question.answers.forEach((answerItem) => {
        if (answerItem.reset === 'unique') {
          delete updatedAnswers[answerItem.key];
        }
      });
    }

     if (value == null || value === '') {
       delete updatedAnswers[key];
     } else {
       updatedAnswers[key] = value;
     }
    this.updateStateIfMounted({answers: this.computeNewVisibleSelectedCriteria(updatedAnswers)});
  }

  renderStepper = () => {
    return (
      <StepperWrapper>
        <Scrollbars>
          <StepperScrollbarContent>
            {
              this.state.steps.map((step, idx) => {
                const isLastStep = idx === this.state.steps.length - 1;
                const done = (idx < this.state.activeStepIndex);
                const allMandatoryQuestionHaveBeenAnswered = this.allMandatoryQuestionsHaveBeenAnswered();
                const disabled = (idx > this.state.activeStepIndex + 1) || ((idx === this.state.activeStepIndex + 1) && (!this.canGoToNextStep() || !allMandatoryQuestionHaveBeenAnswered.allMandatoryAnswered));
                return (
                  <Fragment key={idx}>
                    <StepWrapper
                      key={idx}
                      $disabled={disabled}
                      onClick={() => {
                        this.updateStateIfMounted({ activeStepIndex: idx });
                      }}
                    >
                      <StepLineWrapper>
                        {idx > 0 ? <Line $done={idx <= this.state.activeStepIndex}/> : <EmptySpace/>}
                        <CircleWrapper
                          key={idx}
                          $done={done}
                          $active={idx === this.state.activeStepIndex}
                          $disabled={disabled}
                        >
                          <CircleMask></CircleMask>
                          {!done && <EmptyCircle></EmptyCircle>}
                          {done && (
                            <MsxIconsSvg>
                              <MsxIcons name={'done'} size={'small'}></MsxIcons>
                            </MsxIconsSvg>
                          )}
                        </CircleWrapper>
                        {!isLastStep ? <Line $done={idx < this.state.activeStepIndex}/> : <EmptySpace/>}
                      </StepLineWrapper>
                      <StepInformationWrapper>
                        <StepTitle title={step.name}>
                          {I10n.getOrDefault(`screen.licence_selector.modal.stepper.name.${step.labelKey}`, step.name)}
                        </StepTitle>
                      </StepInformationWrapper>
                    </StepWrapper>
                  </Fragment>
                );
              })
            }
          </StepperScrollbarContent>
        </Scrollbars>
      </StepperWrapper>
    );
  };

  canGoToNextStep = () => {
    let result = false;

    if (!this.state.stepsLoading && this.state.steps[this.state.activeStepIndex + 1]) {
      const nextStep = this.state.steps[this.state.activeStepIndex + 1];
      const conditions = (nextStep.activeIf || []);
      result = disjunctionConditionsMatchingUserAnswers(conditions, this.state.answers)
    }

    return result;
  }

  /**
   *
   * Get the numeric value associated with the key/value pair. 0/1 for a boolean value, any number
   * for a numeric value or 0 is the value is not set.
   *
   * @param {string} key
   * @param {string} value
   *
   * @returns value
   */
  getParameterValue = (key, value, answers) => {
    let result;
    if (value == null) {
      try {
        if (answers[key] == null) {
          result = 0;
        } else {
          result = parseInt(answers[key]);
        }
      } catch(e) {
        result = 0;
      }
    } else {
      if (answers[key] === value) {
        result = 1;
      } else {
        result = 0;
      }
    }

    return result;
  }

  extractUsedAndUnusedFormulasVariables = (formulas, scopedLicences) => {
    const usedFormulaCriteria = {};
    const filteredFormulaCriteria = {};

    for (const formula of formulas) {
      let resultToInsert;
      if (scopedLicences[formula.id]) {
        resultToInsert = usedFormulaCriteria;
      } else {
        resultToInsert = filteredFormulaCriteria;
      }

      const variablesToReplace = new Set([...(formula.formula || '').matchAll(/\[(.*?)\]/g)].map((x) => x[1]));
      for (const variable of variablesToReplace) {
        const variableWithValueSplit = variable.split(':');
        let variableName = variableWithValueSplit[0];
        let valueName = variableWithValueSplit[1] || null; // Variables with a parameter are supposed to be boolean values, otherwise we will chek for the numeric value associated.
        resultToInsert[variableName + '_' + valueName] = true;
      }
    }

    Object.keys(filteredFormulaCriteria).forEach(key => {
      if (usedFormulaCriteria[key]) {
        delete filteredFormulaCriteria[key];
      }
    });

    return {usedFormulaCriteria, filteredFormulaCriteria};

  }

  computeFormula = (formulaObject, answers) => {
    let result = 0;
    let newFormula = formulaObject.formula;
    try {
      const variablesToReplace = new Set([...newFormula.matchAll(/\[(.*?)\]/g)].map((x) => x[1]));
      for (const variable of variablesToReplace) {
        const variableWithValueSplit = variable.split(':');
        let variableName = variableWithValueSplit[0];
        let valueName = variableWithValueSplit[1] || null; // Variables with a parameter are supposed to be boolean values, otherwise we will chek for the numeric value associated.
        const value = this.getParameterValue(variableName, valueName, answers);
        newFormula = newFormula.replace(new RegExp(`\\[${variable}\\]`, 'g'), value);
      }
      result = Math.ceil(this.state.parser.evaluate(newFormula, {}));
    } catch(e) {
      console.log('An error occured when evaluating the formula : ', formulaObject);
      console.log(e);
    }

    return result;
  }

  computeLicencesToAddAsObject = (withOptimization) => {
    const licencesToAdd = {};

    Object.values(this.state.formulas).forEach(formulaObject => {
      const quantity = this.computeFormula(formulaObject, {...this.state.answers, optimizeLicenses: withOptimization ? 'true' : 'false'});
      if (quantity > 0) {
        licencesToAdd[formulaObject.id] = quantity;
      }
    });

    if (withOptimization) {
      for (const optimizedResult of this.computeAdvancedOptimizationFormulas()) {
        licencesToAdd[optimizedResult.id] = optimizedResult.quantity;
      }
    }

    return licencesToAdd;
  }

  computeLicencesToAdd = () => {
    const licencesToAdd = [];

    Object.values(this.state.formulas).forEach(formulaObject => {
      const quantity = this.computeFormula(formulaObject, this.state.answers);
      if (quantity > 0) {
        licencesToAdd.push({id: formulaObject.id, quantity, softwareLicence: formulaObject.softwareLicence});
      }
    });

    if (this.state.optimizeLicenses) {
      licencesToAdd.push(...this.computeAdvancedOptimizationFormulas());
    }

    return licencesToAdd;
  }

  computeAdvancedOptimizationFormulas = () => {
      const licencesToAdd = [];
      for (const optimizationGroup of this.state.advancedOptimizationGroups) {

        const targettedScore = this.computeFormula({
          formula: optimizationGroup.formula
        }, this.state.answers);

        if (targettedScore > 0) {
          let bestMatchForGroup;
          for (const optimizationItem of optimizationGroup.items) {

            const quantityNeeded = Math.ceil(targettedScore / (optimizationItem.packQuantity));
            const scoreForReference =  quantityNeeded * optimizationItem.weigthFormula;

            if (quantityNeeded > 0 && (bestMatchForGroup == null || (scoreForReference <= bestMatchForGroup.score))) {
              bestMatchForGroup = {
                reference:  optimizationItem.reference,
                quantity: quantityNeeded,
                score: scoreForReference,
                softwareLicence: optimizationItem.softwareLicence
              };
            }
          }

          if (bestMatchForGroup && bestMatchForGroup.quantity > 0) {
            licencesToAdd.push(
              {id: bestMatchForGroup.reference, quantity: bestMatchForGroup.quantity, softwareLicence: bestMatchForGroup.softwareLicence}
            );
          }
        }
      }
      return licencesToAdd;
  }

  validateButtonAction = (callback) => {
    const { allMandatoryAnswered, unansweredQuestionElement } = this.allMandatoryQuestionsHaveBeenAnswered();
    if (allMandatoryAnswered) {
      callback();
    } else {
      if (this.scrollComponent && unansweredQuestionElement) {
        try {
          this.scrollComponent.view.scrollTo({
            top: unansweredQuestionElement.offsetTop,
            behavior: "smooth",
          });
        } catch(err) {}
        this.updateStateIfMounted({
          showNotification: true,
          notificationType: 'error',
          notificationText: I10n.get('screen.licence_selector.modal.notification.mandatory_questions_not_answered'),
        });
        setTimeout(() => {
          this.updateStateIfMounted({ showNotification: false });
        }, 10000);
      }
    }
  }

  renderNavigationButton = () => {
    return(
      !this.state.stepsLoading && <>
        {this.state.activeStepIndex > 0 && <PreviousWrapper>
            <Button icon-name="arrow-left" onClick={() => {
                this.updateStateIfMounted({activeStepIndex: this.state.activeStepIndex - 1});
              }}>
                {I10n.get('app.action.previous')}
            </Button>
        </PreviousWrapper>}
        {this.canGoToNextStep() ? <Button key={"continue"} importance="emphasized" disabled={this.state.stepsLoading} onClick={() => {
          this.validateButtonAction(() => {
            this.updateStateIfMounted({activeStepIndex: this.state.activeStepIndex + 1});
          });
        }}>{I10n.get('app.action.continue')}</Button> :
        <ValidateWrapper>
          <Button
            icon-name="check-small"
            importance="emphasized"
            disabled={this.state.stepsLoading}
            onClick={() => {
              this.validateButtonAction(() => {
                this.props.onSubmit(this.computeLicencesToAdd(), true);
              });
            }}
          >
            {I10n.get('app.action.validate')}
          </Button>
        </ValidateWrapper>}
      </>
    );
  }

  buildLicensePackageSummaryActionButtons = () => {
    const result = [];

    if (!this.state.stepsLoading && !this.canGoToNextStep()) {
      result.push({
        action: () => {
          const { allMandatoryAnswered, unansweredQuestionElement } = this.allMandatoryQuestionsHaveBeenAnswered();
          if (allMandatoryAnswered) {
            if (this.canGoToNextStep()) {
              this.updateStateIfMounted({activeStepIndex: this.state.activeStepIndex + 1});
            } else {
              this.props.onSubmit(this.computeLicencesToAdd(), false);
            }
          } else {
            if (this.scrollComponent && unansweredQuestionElement) {
              try {
                this.scrollComponent.view.scrollTop = unansweredQuestionElement.offsetTop;
              } catch(err) {}
              this.updateStateIfMounted({
                showNotification: true,
                notificationType: 'error',
                notificationText: I10n.get('screen.licence_selector.modal.notification.mandatory_questions_not_answered'),
              });
              setTimeout(() => {
                this.updateStateIfMounted({ showNotification: false });
              }, 10000);
            }
          }
        },
        label: I10n.get('screen.licence_selector.add_other_license')
      },
      {
        action: () => {
          const { allMandatoryAnswered, unansweredQuestionElement } = this.allMandatoryQuestionsHaveBeenAnswered();
          if (allMandatoryAnswered) {
            if (this.canGoToNextStep()) {
              this.updateStateIfMounted({activeStepIndex: this.state.activeStepIndex + 1});
            } else {
              this.props.onSubmit(this.computeLicencesToAdd(), true);
            }
          } else {
            if (this.scrollComponent && unansweredQuestionElement) {
              try {
                this.scrollComponent.view.scrollTop = unansweredQuestionElement.offsetTop;
              } catch(err) {}
              this.updateStateIfMounted({
                showNotification: true,
                notificationType: 'error',
                notificationText: I10n.get('screen.licence_selector.modal.notification.mandatory_questions_not_answered'),
              });
              setTimeout(() => {
                this.updateStateIfMounted({ showNotification: false });
              }, 10000);
            }
          }
        },
        importance: 'emphasized',
        icon: 'check-small',
        label: I10n.get('app.action.validate')
      });

    }
    return result;
  }

  canOptimize = () => {
    const nonOptimizedLicenses = this.computeLicencesToAddAsObject(false);
    const withOptimizedLicenses = this.computeLicencesToAddAsObject(true);
    let canOptimize = true;
    let optimizationHint;
    console.log(this.state.optimizationItems);

    canOptimize = Object.entries(withOptimizedLicenses).some(([key, value]) => {
        if (optimizationHint == null && this.state.optimizationItems[key] && this.state.optimizationItems[key].optimizationHintLabelKey) {
          optimizationHint = I10n.getOrDefault(`screen.licence_selector.modal.optimization_hint.${this.state.optimizationItems[key].optimizationHintLabelKey}`, this.state.optimizationItems[key].optimizationHintLabel);
        }
        return nonOptimizedLicenses[key] !== value;
      });

    return {
      canOptimize,
      optimizationHint
    };
  }


  render = () => {
    const licensesToAdd = this.computeLicencesToAdd();
    const packageSummaryLicenses =  licensesToAdd.map(licenceToAdd => {
      return {
        ...licenceToAdd.softwareLicence,
        quantity: licenceToAdd.quantity,
      };
    }).sort((a,b) => a.order - b.order);

    const licenseGroupsForSummary = buildLicenseGroups(packageSummaryLicenses);
    const nbLicensesAdded = licenseGroupsForSummary.flatMap(licenseGroup => {
      return licenseGroup.licences.map(license => license);
    })
    .filter(licence => licence.ignoreGlobalQuantity == null || licence.ignoreGlobalQuantity === false)
    .reduce((accumulator, license) => {
      return accumulator + license.quantity;
    }, 0);


    console.log(licensesToAdd);
    console.log(this.state.answers);

    const canOptimizeObject = this.canOptimize();

    return (
      <Container $windowModeEnabled={this.props.windowModeEnabled}>
        <Header>
          <TitleWrapper>
            <Title>{I10n.get(`screen.licence_selector.${this.props.softwareSelection}.title`)}</Title>
          </TitleWrapper>
          <CloseIcon onClick={(e) => {
            e.preventDefault();
            this.props.closeModal();
          }}>
            <MsxIcons name="close"></MsxIcons>
          </CloseIcon>
        </Header>
        {!this.state.stepsLoading && this.state.steps.length > 1 && this.renderStepper()}
        {packageSummaryLicenses.length > 0 && <MobilePackageSummaryWrapper $isOpen={this.state.mobilePackageSummaryOpen} onClick={() => {
          this.updateStateIfMounted({mobilePackageSummaryOpen: !this.state.mobilePackageSummaryOpen});
        }}>
          <MobilePackageSupparyLabel>{I10n.get("screen.licence_selector.package_summary")}</MobilePackageSupparyLabel>
          <MobileChipAndIconWrapper>
            <Counter><CounterLabel>{nbLicensesAdded >= 100 ? '99+' : nbLicensesAdded }</CounterLabel></Counter>
            <MobileIconWrapper $isOpen={this.state.mobilePackageSummaryOpen}>
              <MsxIcons name="down-arrow"></MsxIcons>
            </MobileIconWrapper>
          </MobileChipAndIconWrapper>
        </MobilePackageSummaryWrapper>}
        <ContentAndSubmitWrapper>
          <MobilePackageSummaryPositioner>
            <MobilePackageSummaryContentWrapper $isOpen={this.state.mobilePackageSummaryOpen}>
              {this.state.mobilePackageSummaryOpen && <LicenseSelectorPackageSummaryContent
                licenseGroups={licenseGroupsForSummary}
                isOpen={true}
                canOptimize={canOptimizeObject.canOptimize}
                optimizationHintLabel={canOptimizeObject.optimizationHint}
                optimizeLicenses={this.state.optimizeLicenses}
                disabled={this.props.disabled}
                onOptimizeChange={() => {
                  this.setState({optimizeLicenses: !this.state.optimizeLicenses}, () => {
                    this.updateStateIfMounted({answers: this.computeNewVisibleSelectedCriteria(this.state.answers)});
                  });
                }}
                removeSoftwareLicence={this.props.removeSoftwareLicence}
                actionButtons={this.props.actionButtons}
                onClear={this.props.onClear}
              >
              </LicenseSelectorPackageSummaryContent>}
            </MobilePackageSummaryContentWrapper>
          </MobilePackageSummaryPositioner>
          <Content>
            {this.state.stepsLoading ? <SkeletonWrapper>
                <Skeleton nbCols={2} expand={true}></Skeleton>
                <Skeleton nbCols={2} expand={true}></Skeleton>
              </SkeletonWrapper> : <>
              <ContentScrollbarsWrapper>
                <Scrollbars ref={c => { this.scrollComponent = c }}>
                  <ScrollbarContent>
                    {this.renderActiveQuestionsGroups()}
                  </ScrollbarContent>
                </Scrollbars>
              </ContentScrollbarsWrapper>
              {<LicenseSelectorPackageSummaryWrapper>
                <LicenseSelectorPackageSummary
                  licenseGroups={licenseGroupsForSummary}
                  licenseModel={this.props.licenseModel}
                  availableLicenseModels={this.props.availableLicenseModel || []}
                  actionButtons={this.buildLicensePackageSummaryActionButtons()}
                  canOptimize={canOptimizeObject.canOptimize}
                  optimizationHintLabel={canOptimizeObject.optimizationHint}
                  optimizeLicenses={this.state.optimizeLicenses}
                  onOptimizeChange={() => {
                    this.setState({optimizeLicenses: !this.state.optimizeLicenses}, () => {
                      this.updateStateIfMounted({answers: this.computeNewVisibleSelectedCriteria(this.state.answers)});
                    });
                  }}
                >
              </LicenseSelectorPackageSummary></LicenseSelectorPackageSummaryWrapper>}
            </>}
          </Content>
          {this.state.showNotification && (
            <CustomNotification
              type={this.state.notificationType}
              text={this.state.notificationText}
              hideNotification={() => this.updateStateIfMounted({ showNotification: false })}
            />
          )}
          <SubmitWrapper>
            {this.renderNavigationButton()}
          </SubmitWrapper>
        </ContentAndSubmitWrapper>
      </Container>
    );
  }
}

export default ModalSoftwareLicenceSelector;
